import { IS_OVERVIEW_APP, IS_SELFNET_APP } from 'src/app/models/users/users.model';

/**
 * Application of the pages driven by the global supplier, by route path.
 * A page not listed here is always enabled.
 */
export const GLOBAL_SUPPLIER_PAGE_APPS: { [path: string]: string } = {
  // Overview
  'dashboard': IS_OVERVIEW_APP,
  'suppliers': IS_OVERVIEW_APP,
  'pricedevices': IS_OVERVIEW_APP,
  'companies': IS_OVERVIEW_APP,
  'fuelstation-level-price': IS_OVERVIEW_APP,
  'products-configuration': IS_OVERVIEW_APP,
  'tanks-configuration': IS_OVERVIEW_APP,
  'totalizers-dispensers-configuration': IS_OVERVIEW_APP,
  'dc-versions': IS_OVERVIEW_APP,
  'fuelstations-registry-configuration': IS_OVERVIEW_APP,
  'datacollectionv1': IS_OVERVIEW_APP,
  'datacollection': IS_OVERVIEW_APP,
  'supplies': IS_OVERVIEW_APP,
  'oilcharges': IS_OVERVIEW_APP,
  'telematic-register': IS_OVERVIEW_APP,
  'iut-outcome': IS_OVERVIEW_APP,
  'mise': IS_OVERVIEW_APP,
  'adm': IS_OVERVIEW_APP,
  'totalizers': IS_OVERVIEW_APP,

  // Selfnet
  'chip-cards-invoices': IS_SELFNET_APP,
  'vendors': IS_SELFNET_APP,
  'terminals': IS_SELFNET_APP,
  'pos': IS_SELFNET_APP,
  'analysis-terminals': IS_SELFNET_APP,
  'erogazioniPendenti': IS_SELFNET_APP,
  'pending-fuelcoupons': IS_SELFNET_APP,
  'analisidati': IS_SELFNET_APP,
  'invoices': IS_SELFNET_APP,
  'invoice-details': IS_SELFNET_APP,
  'customersduplicate': IS_SELFNET_APP,
  'history': IS_SELFNET_APP,
  'invoice-go': IS_SELFNET_APP,
  'card-tracks': IS_SELFNET_APP,
};
